import m from "mithril";
import { MithrilTsxComponent } from "mithril-tsx-component";
import { DEFAULT_IMAGE, getProductName } from "../../state/api";
import { getTextFixed } from "../../state/translations";
import { formatCurrency, getAsset } from "../../utils/utils";
import { QuantitySelector } from "../quantity-selector/quantity-selector";
import { Svg } from "../svg/svg";
import { cleanString } from "oj-utils";
import { sharedProductUtils } from "../productDetail/productDetail";
import "./finalizeConfigurationItem.scss";
import { RelatedProducts } from "./relatedProducts";
import { isLoggedIn, openLoginModal } from "../../utils/login";
import { Button } from "../button/button";
export class FinalizeConfigurationItem extends MithrilTsxComponent {
    openDocumentsList = false;
    view(v) {
        const { article } = v.attrs;
        const name = getProductName(article.item);
        const thumbnail = article.item.thumbnail;
        const price = (article.item.price ?? 0); // * (article.aantal ?? 1)
        const documents = article.item.documents?.filter(document => !!document?.url) ?? [];
        return m("article", { className: "FinalizeConfigurationItem" },
            m("div", { className: "main" },
                m("div", { className: "image" },
                    m("img", { src: thumbnail ?? DEFAULT_IMAGE, alt: name, className: cleanString(!thumbnail && "is-fallback-image") })),
                m("div", { className: "content" },
                    m("div", { className: "info" },
                        m("div", { className: "heading" },
                            m("button", { onclick: (e) => {
                                    sharedProductUtils.openDialog(e, article.item);
                                } }, name),
                            isLoggedIn
                                ? m("span", null, price ? formatCurrency(price) : "€-,--")
                                : m(Button, { className: "button-grey", onclick: openLoginModal },
                                    m("span", { className: "fs5" }, getTextFixed("LOGIN_MESSAGE")))),
                        m("div", { className: "text" },
                            m("span", null, article.artCodeTSNL),
                            m("span", null, getTextFixed("EXC_VAT"))),
                        m("div", { className: "technical-info" },
                            m("div", { className: "documents" },
                                m("button", { className: cleanString("technical-drawing-button", this.openDocumentsList && "open"), type: "button", disabled: documents.length === 0, onclick: () => {
                                        if (documents.length === 1)
                                            window.open(documents[0].url, "_blank", "noopener,noreferrer");
                                        else
                                            this.openDocumentsList = !this.openDocumentsList;
                                    } },
                                    m(Svg, { className: "icon", src: getAsset("icons/documents.svg") }),
                                    m("span", null, getTextFixed(documents.length > 1 ? "TECHNICAL_DRAWINGS" : "TECHNICAL_DRAWING")),
                                    documents.length > 1 && m(Svg, { className: "dropdown-icon", src: getAsset("icons/chevron-down.svg") })),
                                documents.length > 1 && m("div", { className: cleanString("documents-list", this.openDocumentsList && "open") }, documents.map(document => m("a", { href: document.url, target: "_blank", rel: "noopener noreferrer" },
                                    m(Svg, { className: "icon", src: getAsset("icons/pdf.svg") }),
                                    m("span", { className: "fs5" }, document.title))))),
                            m("div", { className: cleanString("delivery-time", !article.item.stock?.amount && "out-of-stock") },
                                m(Svg, { className: "icon", src: getAsset(article.item.stock?.amount ? "icons/truck.svg" : "icons/x-circle.svg") }),
                                m("span", null, getTextFixed(article.item.stock?.amount ? "IN_STOCK" : "OUT_OF_STOCK"))))),
                    m("div", { className: "item-footer" },
                        m(QuantitySelector, { min: 1, value: article.qty, onchange: v.attrs.onquantity }),
                        m("button", { className: "remove", type: "button", onclick: v.attrs.ondelete },
                            m(Svg, { className: "icon", src: getAsset("icons/trash-2.svg") }),
                            m("span", null, getTextFixed("REMOVE")))))),
            m(RelatedProducts, { article: article }));
    }
}
